import { checkYearIsSameOrBefore } from './format-date';

import { InputMinLength, InputTextError, Regex } from 'src/constants';

export const getEmailError = (email: string) => (email.length ? InputTextError.EMAIL_FORMAT : '');
export const getMessageError = (message: string) =>
  message.length < InputMinLength.MESSAGE ? InputTextError.MESSAGE_MIN_LENGTH : '';
export const getNameError = (name: string) =>
  name.length < InputMinLength.TEXT ? InputTextError.NAME_MIN_LENGTH : '';
export const getFirstNameError = (firstName: string) =>
  firstName.length < InputMinLength.TEXT ? InputTextError.FIRST_NAME_MIN_LENGTH : '';
export const getLastNameError = (lastName: string) =>
  lastName.length < InputMinLength.TEXT ? InputTextError.LAST_NAME_MIN_LENGTH : '';
export const getPhoneError = (phone: string) => (phone.length ? InputTextError.PHONE_FORMAT : '');
export const getYearError = (year: string) =>
  Regex.YEAR.test(year) && !checkYearIsSameOrBefore(year) ? InputTextError.YEAR_LATER : '';
